import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

const BottomSheetHandle = ({ sx }) => (
  <Box aria-hidden="true" sx={{ width: 42, height: 4, borderRadius: 999, bgcolor: 'divider', mx: 'auto', flexShrink: 0, ...sx }} />
);

BottomSheetHandle.propTypes = { sx: PropTypes.object };
BottomSheetHandle.defaultProps = { sx: {} };

export default BottomSheetHandle;
